// extracted by mini-css-extract-plugin
export default {"entry":"vertical-field_entry__B3T62","labels":"vertical-field_labels__SOQDw","required":"vertical-field_required__PoNCM"};